import { AdminService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { layoutsKeys } from 'app/queries/layouts/layoutsKeys';
import type { TCall } from 'app/queries/types/TCall';
import { normalizeLayoutsResponse } from '../helpers/normalizeLayoutsResponse';

type TParams = QueryFunctionContext<ReturnType<typeof layoutsKeys.list>>;

export const createFetchOrganizationLayoutsQueryFn =
  (call: TCall) =>
  async ({ queryKey: [{ organizationId, params }], signal }: TParams) =>
    normalizeLayoutsResponse(
      await call(() =>
        cancelOnSignal(
          AdminService.getOrganizationLayoutsAsAdmin({
            oid: organizationId,
            pageNo: params.page.toString(),
            pageSize: params.pageSize.toString(),
            orderBy: params.orderBy,
            orderType: params.orderType,
            search: params.search,
          }),
          signal,
        ),
      ),
    );
